import {ref} from 'vue';
import {useSnackbarStore} from "@/stores/snackBarStore";

export function useClipboard() {
    const {showSnackbar} = useSnackbarStore();
    const copySuccess = ref(false);
    const copyError = ref(null);

    const copyToClipboard = async (text) => {
        try {
            await navigator.clipboard.writeText(text);
            copySuccess.value = true;
            copyError.value = null;
            showSnackbar("Copied to clipboard");
        } catch (err) {
            copySuccess.value = false;
            copyError.value = err;
            showSnackbar("Couldn't copy to clipboard", 'error');
        }
    };

    return {
        copySuccess,
        copyError,
        copyToClipboard,
    };
}
